import { Injectable } from '@angular/core';

import { RedirectCommand, RedirectStrategy } from '@guardfinder/shared';

import { RedirectStrategies } from './redirect-strategies';

@Injectable()
export class UserLogoutRedirectStrategy implements RedirectStrategy {
    private readonly welcomeScreenRedirectCommand: RedirectCommand = { path: '/welcome' };

    async execute(): Promise<RedirectCommand> {
        return this.welcomeScreenRedirectCommand;
    }

    strategyName(): string {
        return RedirectStrategies.USER_LOGOUT;
    }
}
